/** Swaps the non-breaking spaces Word/Docs paste in for ordinary ones — they never line-wrap, so long text overflows. Nothing else is touched. */
export const cleanPastedHtml = (html: string): string => {
	if (!html) return html;

	// DOMParser decodes `&nbsp;` to U+00A0, so matching the character covers both spellings.
	const doc = new DOMParser().parseFromString(html, 'text/html');
	const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

	while (walker.nextNode()) {
		const node = walker.currentNode;
		node.textContent = (node.textContent ?? '').replace(/\u00A0/g, ' ');
	}

	return doc.body.innerHTML;
};
